import React from 'react'
import PropTypes from 'prop-types'
import Colors from "./Colors"
import Scroll from "../img/scroll.png"
import {Link} from "react-scroll";

class HomeHero extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <section className="hero is-fullheight" style={{backgroundColor: Colors.orange}}>
                    <div className="hero-head">
                    </div>

                    <div className="hero-body">
                        <div className="container has-text-centered">
                            <div className='embed-container'>
                                <iframe
                                    src="https://player.vimeo.com/video/286301138?autoplay=1&color=ffca35&title=0&byline=0&portrait=0&muted=1"
                                    frameBorder="0"
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    allowFullScreen="true"></iframe>
                            </div>

                            <div className="has-text-centered">
                                <h2 className="title is-3" style={{marginTop: 20}}>Jenn Emerling wants you to See America!</h2>
                            </div>
                        </div>
                    </div>

                    <div className="hero-foot">
                        <div className="has-text-centered">
                            <p>
                                <Link className="" to="layout-wrapper" spy={true} smooth={true} duration={500}>
                                    <img src={Scroll} style={{maxWidth: 64, marginTop: 10, marginBottom: 20}}/>
                                </Link>
                            </p>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

HomeHero.propTypes = {};

export default HomeHero


// WEBPACK FOOTER //
// ./src/components/HomeHero.js